import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import HeaderCommon from "../../components/header-tab/fixed-common-header";
import OrderStatus from "../../pages/cart/pg-orderstatus";
import Paymode from "../../pages/cart/pg-paymode";
import Footer from "../../components/footer-tab/fixedfooter";
import Cart from "../../pages/cart/pg-cart";

export function RTCart(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Cart navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTPaymode(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <Paymode navigate={navigate} params={params} />
    </>
  );
}

export function RTOrderStatus(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <OrderStatus navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}
